import { render, staticRenderFns } from "./rubric_from_scratch.vue?vue&type=template&id=79c2b4aa&scoped=true&"
import script from "./rubric_from_scratch.vue?vue&type=script&lang=js&"
export * from "./rubric_from_scratch.vue?vue&type=script&lang=js&"
import style0 from "./rubric_from_scratch.vue?vue&type=style&index=0&id=79c2b4aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c2b4aa",
  null
  
)

export default component.exports